import React, { useState } from 'react'
import PageHeader from '../../Component/BasicComponents/HeaderBreadCrumbs';
import BasicDataTable from '../../Component/BasicComponents/BasicDataTable';
import RoundedDropdown from '../../Component/BasicComponents/Dropdowns/RoundedDropdown';
import { useNavigate } from 'react-router-dom';
import RouteModal from '../../Component/BasicComponents/Modal/RouteModal';
import ReusableDropdown from '../../Component/BasicComponents/Dropdowns/Dropdown';
import { Btn } from '../../AbstractElements';
import { FaEdit, FaEye } from 'react-icons/fa'
import { useMTPListData, useMTPMonths, useMTPStatus } from './hooks/useMTP';
import { useGetOrgUnitsData } from '../FSM/Beats_Patches/hooks/useBeat';
import { useGetGradeMastersData } from '../Employee/hooks/useEmployee';
import MTPAddAndEditModal from './hooks/MTPAddAndEditModal';
import { BASE_URL } from '../../Api/config';
import { downloadExcelGet } from '../../utils/ExcelDownload';

const MtpColumns = (handleMtpView: (row: any) => void, handleEditMTP: (row: any) => void) => [
    {
        name: "Org Unit",
        selector: (row: { OrgUnitName: string }) => row.OrgUnitName || '-',
        sortable: true,
        width: '200px',
        wrap: true
    },
    {
        name: "Position",
        selector: (row: { PositionName: string }) => row.PositionName || '-',
        sortable: true,
        width: '200px',
        wrap: true
    },
    {
        name: "Month",
        selector: (row: { Month: string }) => row?.Month || '-',
        sortable: true,
        width: '200px',
        wrap: true
    },
    {
        name: "Emp Name",
        selector: (row: { EmployeeName: string }) => row?.EmployeeName || '-', // (depend by backend)
        sortable: true,
        width: '200px',
        wrap: true
    },
    {
        name: "Grade",
        selector: (row: { GradeName: string }) => row?.GradeName || '-', // (depend by backend)
        sortable: true,
        width: '200px',
        wrap: true
    },
    {
        name: "Status",
        selector: (row: { MtpStatus: string }) => row?.MtpStatus || '-', // (depend by backend)
        sortable: true,
        width: '200px',
        wrap: true
    },
    {
        name: "Actions",
        cell: (row: any) => (
            <div className="d-flex align-items-center" style={{}}>
                <div className="d-flex align-items-center">
                    <button
                        onClick={() => handleEditMTP(row)}
                        className="btn btn-primary"
                        style={{ borderRadius: "20px", padding: "2px", width: "70px" }}
                    >
                        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
                    </button>
                </div>
                <div className="d-flex align-items-center" style={{ marginLeft: 10 }}>
                    <button
                        onClick={() => handleMtpView(row)}
                        className="btn btn-primary"
                        style={{ borderRadius: "20px", padding: "2px", width: "70px", backgroundColor: '#2e8dd3' }}
                    >
                        <FaEye style={{ fill: "#fff" }} />View
                    </button>
                </div>
            </div>
        ),
        width: "200px"
    },
]

const HeaderContent = (props: any) => {
    const handleFilter = (key: any, selected: any) => {
        props?.setPaginationStates((prev: any) => ({ ...prev, [key]: selected || null }))
    }

    return (
        <div
            style={{
                marginBottom: "15px",
                display: "flex",
                justifyContent: "flex-end",
            }}
        >
            <div>
                <RoundedDropdown
                    options={props?.mtpMonths || []}
                    onSelect={(e: any) => { handleFilter('month', `${e?.id?.split("-").reverse()?.join("-") || ''}`) }}
                    defaultLabel="All"
                    width="20px"
                    isShowHeading
                    DropdownHeading="Month"
                    headingColor="#2e8dd3"
                />
            </div>
            <div style={{ marginLeft: 10 }}>
                <RoundedDropdown
                    options={props?.orgData || []}
                    onSelect={(e: any) => { handleFilter('orgUnitId', Number(e?.id)) }}
                    defaultLabel="All"
                    width="20px"
                    isShowHeading
                    DropdownHeading="Organization"
                    headingColor="#2e8dd3"
                />
            </div>
            <div style={{ marginLeft: 10 }}>
                <RoundedDropdown
                    options={props?.gradeData || []}
                    onSelect={(e: any) => { handleFilter('gradeId', Number(e?.id)) }}
                    defaultLabel="All"
                    width="20px"
                    isShowHeading
                    DropdownHeading="Grade"
                    headingColor="#2e8dd3"
                />
            </div>
            <div style={{ marginLeft: 10 }}>
                <RoundedDropdown
                    options={props?.MTPStatusData || []}
                    onSelect={(e: any) => { handleFilter('mtpStatus', e?.id) }}
                    defaultLabel="All"
                    width="auto"
                    isShowHeading
                    DropdownHeading="Status"
                    headingColor="#2e8dd3"
                />
            </div>
        </div>
    )
}

const Mtp = () => {
    const navigate = useNavigate();
    const { data: orgUnitsData } = useGetOrgUnitsData({ enable: true });
    const [paginationStates, setPaginationStates] = useState({
        search: null,
        page: 1,
        limit: 10,
        orgUnitId: null,
        gradeId: null,
        designationId: null,
        mtpStatus: null,
        month: null,
    })
    const { data,isLoading:mtpListDataIsLoading} = useMTPListData({
        enable: true, params: {
            limit: paginationStates.limit,
            page: paginationStates.page,
            search: paginationStates.search,
            orgUnitId: paginationStates.orgUnitId,
            gradeId: paginationStates.gradeId,
            designationId: paginationStates.designationId,
            mtpStatus: paginationStates.mtpStatus,
            month: paginationStates.month,
        }
    })
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { data: mtp_months } = useMTPMonths({ enable: true, params: { startMonth: 0, allowedMonths: isModalOpen ? 2 : 4 } });
    const { data: mtp_status } = useMTPStatus({ enable: true });
    const { data: gradeMaster } = useGetGradeMastersData({ enable: true });
    const [rowData, setRowData] = useState(null)
    const [checkAddEditStatus, setCheckAddEditStatus] = useState<any>('')
    const [disabled,setDisabled] = useState<boolean>(false);     

    const handleEditMTP = (row: any) => {
        setRowData(row)
        setCheckAddEditStatus('Edit')
        setIsModalOpen(true)
    }

    const handleMtpView = (row: any) => {
        navigate('/mtpDetailView', { state: { mtpRowData: row } })
    }
    const toggleModal = () => {
        setCheckAddEditStatus('Add')
        setIsModalOpen(!isModalOpen);
    }

    const handlePagination = (pageNo: number) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                page: pageNo,
            };
        });
    };
    const handleSearch = (searchValue: any) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                search: searchValue,
            };
        });
    };

    const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
        setPaginationStates((prevState: any) => {
            return {
                ...prevState,
                page: pageNo,
                limit: limit,
            };
        });
    };
    
    const handleDownload = async(fileType:string)=>{
       const appToken = localStorage.getItem('Apptoken')||'';
       const params:Record<string,any>={
        ...(paginationStates.search ===null ?{}:{search:paginationStates.search}),
        ...(paginationStates.orgUnitId === null ?{}:{orgUnitId:paginationStates.orgUnitId}),
        ...(paginationStates.gradeId === null ?{}:{gradeId:paginationStates.gradeId}),
        ...(paginationStates.designationId === null ?{}:{designationId:paginationStates.designationId}),
        ...(paginationStates.mtpStatus === null? {}:{mtpStatus:paginationStates.mtpStatus}),
        ...(paginationStates.month === null ?{}:{month:paginationStates.month})

      }
      const queryString = new URLSearchParams(params).toString();
      const apiEndpoint = `${BASE_URL}admin/api/getMTPListExcel?${queryString}`
      const fileName = 'MTP.xlsx'
      try{ 
        setDisabled(true);
        const response = await downloadExcelGet({apiEndpoint,appToken,fileName});
          
        if(response.success){
            setDisabled(false);     
        }
      }catch(error:any){
         console.log('Error while downloading MTP excel');
      }finally{
        setDisabled(false);
      }
    }

    return (
        <div className="p-4">
            <PageHeader
                title="MTP"
                buttons={[
                    {
                        label: "+ Add MTP",
                        onClick: toggleModal,
                        color: "#2e8dd3",
                    },
                    {
                        label:'Excel',
                        onClick:()=>handleDownload('Excel'),
                        color:disabled?"#888" : "#43B9B2",
                        disable:disabled
                        
                    }

                ]}
            />
            <BasicDataTable
               dynamicHeightOnRowsPerPage={true}
                paginationTotalRows={data?.data?.Pagination?.TotalCount || 0}
                onChangePage={(pageNo: number) => { handlePagination(pageNo); }}
                onChangeRowsPerPage={(newPerPage: any, page: any) => {
                    handleonChangeRowsPerPage(newPerPage, page)
                }}
                handleSearch={(val: any) => { handleSearch(val) }}
                Title="MTP list"
                columns={MtpColumns(handleMtpView, handleEditMTP)}
                data={data?.data?.MTPData || []}
                headerContent={
                    <HeaderContent gradeData={gradeMaster?.data} mtpMonths={mtp_months?.data} orgData={orgUnitsData?.data} MTPStatusData={mtp_status?.data} setPaginationStates={setPaginationStates} />
                }
                showSpinner={mtpListDataIsLoading}
            />
            <RouteModal
                isOpen={isModalOpen}
                toggle={toggleModal}
                title="Add MTP"
                size="sm"
                content={
                    <MTPAddAndEditModal mtpStatus={mtp_status?.data} mtpMonths={mtp_months?.data} OrgUnitData={orgUnitsData?.data} rowData={rowData} setCheckAddEditStatus={setCheckAddEditStatus} checkAddEditStatus={checkAddEditStatus} setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} title={checkAddEditStatus == 'Add' ? 'Add MTP' : 'Edit MTP'} />
                }
            />
        </div>
    )
}

export default Mtp
